<!-- eslint-disable -->
<template lang="pug">
    div.header
        img.header__decoration(:src="DECORATION_IMAGE")
        span.header__text
            slot
        img.header__decoration.header__decoration--reverse(:src="DECORATION_IMAGE")
</template>

<script>
    /*eslint-disable*/
    import DECORATION_IMAGE from '../../assets/images/olympiads/decoration.png';

    export default {
        data () {
            return {
                DECORATION_IMAGE
            }
        }
    }
</script>

<style lang="scss" scoped>
    $color-orange: #f37a3b;
    .header {
        display: flex;
        align-items: center;
        justify-content: center;
        @include stack-space($space-base);
        @include media($sm) {
            @include stack-space(0);
        }
        &__decoration {
            height: 100px;
            @include inline-space($space-large);
            display: none;
            @include media($sm) {
                display: unset;
            }
            &--reverse {
                transform: scale(-1, 1);
            }
        }

        &__text {
            color: $color-orange;
            text-align: center;
            @include text($font-size-20, $font-weight-bold);
            @include media($sm) {
                @include inline-space($space-large);
            }
            @include media($lg) {
                @include text($font-size-24, $font-weight-bold);
            }
        }
    }
</style>
